import { Info } from 'components/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/Dialog/Dialog';
export default function RegistrationPendingDialog({
  open,
  onPrimaryBtnClick,
  onClose
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Dialog, {
    isLoading: false,
    dialogTitle: t('register_vehicle.credit_check.existing_agreement_pending_approval'),
    primaryBtnTitle: t('buttons.close'),
    onPrimaryBtnClick: onPrimaryBtnClick,
    primaryBtnClickIsDisabled: false,
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.thank_you_of_autopass_agreement')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.registration_pending')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Info, null, t('register_vehicle.credit_check.will_notify_when_reviewed')));
}